import React from 'react';
import { DOCUMENT_SELECTION_MODES } from '@constants';
import { filterDocDuplicates } from '@reducers/docs';
import { DocumentSelectionModal } from '@containers/DigitalAnalyst/components/DocumentSelectionModal';
import { logger } from '@utils/usefulFuncs';

const CSV_DOC_MODES = [DOCUMENT_SELECTION_MODES.userCsv];

export const CsvDocSelectionModalController = ({ onInit }) => {
  const [activeNodeId, setActiveNodeId] = React.useState(null);
  const [value, setValue] = React.useState([]);
  const onChangeRef = React.useRef(() => {
    logger('CsvDocSelectionModalController onChangeRef is still not set');
  });

  const showModal = (nodeId, currentDocs, onChange) => {
    setActiveNodeId(nodeId);
    setValue(currentDocs || []);
    if (onChange) {
      onChangeRef.current = onChange;
    }
  };

  const hideModal = () => {
    setActiveNodeId(null);
  };

  React.useEffect(() => {
    onInit({ showModal, hideModal });
  }, []);

  if (!activeNodeId) {
    return null;
  }

  const onAddDocument = (docOrDocs) => {
    const docs = Array.isArray(docOrDocs) ? docOrDocs : [docOrDocs];
    const nextValue = filterDocDuplicates([...value, ...docs]);
    onChangeRef.current(nextValue);
    setValue(nextValue);
  };

  const onRemoveDocument = (docOrDocs) => {
    const docs = Array.isArray(docOrDocs) ? docOrDocs : [docOrDocs];
    const docIds = docs.map((d) => d.id);
    const nextValue = value.filter((selectedDoc) => !docIds.includes(selectedDoc.id));
    onChangeRef.current(nextValue);
    setValue(nextValue);
  };

  return (
    <DocumentSelectionModal
      docSelectModes={CSV_DOC_MODES}
      docs={[]}
      isLoadingDocs={false}
      tickers={[]}
      selectedDocs={value}
      handleAddDocument={onAddDocument}
      handleRemoveDocument={onRemoveDocument}
      onDismiss={hideModal}
    />
  );
};
